import { useDeepCompareEffect } from "ahooks"
import { Control, FieldValues, useWatch } from "react-hook-form"

type Props<T extends FieldValues> = {
  onChange: (params) => void
  control: Control<T, object>
}

const AutoSave = <T extends FieldValues, >({ onChange, control }: Props<T>) => {
  const { selectedBlockType, ...values } = useWatch<any>({ control })

  useDeepCompareEffect(() => {
    // `size` is numeric for most blocks (heading/text/spacer/divider) but a
    // string enum ("small"/"medium"/"large") for buttons — only coerce numeric values.
    const numericSize = parseInt(values.size, 10)

    onChange({
      ...values,
      ...(values.size && { size: Number.isNaN(numericSize) ? values.size : numericSize }),
      ...(values.scale && { scale: parseInt(values.scale, 10) }),
      ...(values.paddingTop && { paddingTop: parseInt(values.paddingTop, 10) }),
      ...(values.paddingBottom && { paddingBottom: parseInt(values.paddingBottom, 10) }),
      ...(values.lineHeight && { lineHeight: parseFloat(values.lineHeight) }),
    })
  }, [values, values.emailAttachment?.name])

  return null
}

export default AutoSave
